// removed by extract-text-webpack-plugin
module.exports = {"action-panel":"action-panel"};


//////////////////
// WEBPACK FOOTER
// ./components/fair/fair-business/_BusinessBox.scss
// module id = ./components/fair/fair-business/_BusinessBox.scss
// module chunks = 1